import React, { useEffect, useState } from "react";
import {
  Modal,
  Select,
  Form,
  TimePicker,
  TreeSelect,
  Row,
  Col,
  InputNumber,
  Input,
  Spin,
  DatePicker,
} from "antd";
import moment from "moment";
import {
  openNotificationWithIcon,
  getDaysArray_dmy,
} from "../../../../Function";
import { TaoLichOTApi } from "../../../../../api/getOvertime";
import { ListMemberOfTeamApi } from "../../../../../api/getTeamMember";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
// import "antd-button-color/dist/css/style.css";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { GetDataDuAnApi, TaoDuAnApi } from "../../../../../api/getInfoData";
import { useStepsForm } from "sunflower-antd";

const { RangePicker } = DatePicker;

const ModalAddOvertime = ({
  visible,
  onCancel,
  lsDate,
  data,
  lsMemberId,
  currentTeam,
  lsTeamRoleCreateOT,
  lsDuAn,
  updateData,
  fetchListDuAn,
  userInfo,
}) => {
  const BoxNewSchedule_pro = () => {
    const {
      form,
      current,
      gotoStep,
      stepsProps,
      formProps,
      submit,
      formLoading,
    } = useStepsForm({
      async submit(values) {
        return TaoLichOTApi({
          listUser: values.member,
          ngay: getDaysArray_dmy(
            values.ngaydangky[0]._d,
            values.ngaydangky[1]._d
          ),
          // @ts-ignore
          gio_vao_1:
            values.giovaoca1 === undefined
              ? undefined
              : moment(values.giovaoca1).format("HH:mm"),
          // @ts-ignore
          gio_ra_1:
            values.gioraca1 === undefined
              ? undefined
              : moment(values.gioraca1).format("HH:mm"),
          gioVao:
            values.giovao === undefined
              ? undefined
              : moment(values.giovao).format("HH:mm"),
          // @ts-ignore
          gioRa:
            values.giora === undefined
              ? undefined
              : moment(values.giora).format("HH:mm"),
          gioGiailao: values.giogiailao.toString() || "0",
          gio_giai_lao_1: values.giogiailaoca1.toString() || "0",
          idDuan: values.duan,
        })
          .then((res) => {
            if (res.data.error) {
              openNotificationWithIcon("error", res.data.error);
              return "false";
            }
            updateData();
            onCancel();
            return "ok";
          })
          .catch((err) => {
            if (err.data.error) {
              openNotificationWithIcon("error", err.data.error);
            }
            return "false";
          });
        // return reStatus;
      },
      total: 4,
    });

    const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };

    useEffect(() => {
      form.setFieldsValue({ giogiailao: "0" });
      form.setFieldsValue({ giogiailaoca1: "0" });

      // 231024 Dành cho TH User được phân quyền Tạo cho các team (DS team tạo có thể khác với DS team phần view team)
      // Nếu comment phần này thì phần set team cho quyền Quản lý - Tăng ca - Tạo sẽ không có tác dụng
      // 231024 Đã tạo DS từ bên ngoài hàm, nên ko cần phần này
      // const arrTeam = userInfo.team_permissions
      //   .filter((item) => item.phanquyen__ten_pq === "overtime_create")
      //   .map((item, index) => {
      //     return { idTeam: item.team, team: item.team__tenTeam };
      //   });
      // lsTeam = [...new Set(arrTeam)];
    }, []);

    const FirstStep = () => {
      const [loading, setLoading] = useState(false);
      const [lsMember, setLsMember] = useState([]);
      const [lsMemberSelected, setLsMemberSelected] = useState([]);
      const [lsTeamSelected, setLsTeamSelected] = useState([]);
      const [lsDuAnNew, setLsDuAnNew] = useState(lsDuAn);
      const [nameDuAn, setName] = useState("");
      const [timeStart, setTimeStart] = useState(
        form.getFieldValue("giovao") || null
      );
      const [timeEnd, setTimeEnd] = useState(
        form.getFieldValue("giora") || null
      );
      const [timeStartCa1, setTimeStartCa1] = useState(
        form.getFieldValue("giovaoca1") || null
      );
      const [timeEndCa1, setTimeEndCa1] = useState(
        form.getFieldValue("gioraca1") || null
      );

      const fetchListTeamMember = (params = {}) => {
        setLoading(true);
        ListMemberOfTeamApi({ ...params }).then((res) => {
          setLsMember(res.data);
          setLoading(false);
        });
      };
      useEffect(() => {
        if (lsTeamSelected.length !== 0) {
          fetchListTeamMember({
            idTeam: JSON.stringify(lsTeamSelected),
          });
        }
      }, [lsTeamSelected]);

      const onChangeTeam = (value) => {
        setLsTeamSelected(value);

        let selected = form.getFieldValue("member") || [];
        let teamSelected = form.getFieldValue("team") || [];
        let MemberSelected = lsMember
          .filter((item) => selected.includes(item.id))
          .filter((item) => teamSelected.includes(item.teamId))
          .map((item) => item.id);
        if (lsMember.length > 0) {
          form.setFieldsValue({ member: MemberSelected });
          setLsMemberSelected(MemberSelected);
        }
      };

      const fetchListDuAn = () => {
        GetDataDuAnApi().then((res) => {
          setLsDuAnNew(res.data);
        });
      };

      const fetchTaoDuAn = () => {
        TaoDuAnApi({ ten: nameDuAn.trim() })
          .then((res) => {
            if (res.data.error) {
              openNotificationWithIcon("error", res.data.error);
            } else {
              setName("");
              fetchListDuAn();
            }
          })
          .catch((err) => {
            if (err.data.error) {
              openNotificationWithIcon("error", err.data.error);
            }
          });
      };

      const addItem = (e) => {
        fetchTaoDuAn();
        e.preventDefault();
      };

      const onNameChange = (event) => {
        setName(event.target.value);
      };

      const onKeyPress = (e) => {
        const specialCharRegex = new RegExp("[a-zA-Z0-9 -]");
        const pressedKey = String.fromCharCode(
          !e.charCode ? e.which : e.charCode
        );
        if (!specialCharRegex.test(pressedKey)) {
          e.preventDefault();
          return false;
        }
      };

      const onSelectTimeStartCa1 = (value) => {
        setTimeStartCa1(value);
      };

      const onSelectTimeEndCa1 = (value) => {
        setTimeEndCa1(value);
        // setTimeStart(null);
        // form.setFieldsValue({ giovao: null });

        // setTimeEnd(null);
        // form.setFieldsValue({ giora: null });
      };

      const onSelectTimeStart = (value) => {
        setTimeStart(value);
      };

      const onSelectTimeEnd = (value) => {
        setTimeEnd(value);
      };

      const getDisableHourInCa1 = () => {
        const timeIn = timeEndCa1 ? timeEndCa1._d.getHours() : 24;
        let arrCheck = [...Array(24).keys()];
        return arrCheck.filter((item) => item > timeIn);
      };
      const getDisableHourOutCa1 = () => {
        const timeIn = timeStartCa1 ? timeStartCa1._d.getHours() : 0;
        let arrCheck = [...Array(24).keys()];
        return arrCheck.filter((item) => item < timeIn);
      };

      const getDisableHourIn = () => {
        const timeIn = timeEnd ? timeEnd._d.getHours() : 24;
        let arrCheck = [...Array(24).keys()];
        return arrCheck.filter((item) => item > timeIn);
      };

      const getDisableHourOut = () => {
        const timeIn = timeStart ? timeStart._d.getHours() : 0;
        let arrCheck = [...Array(24).keys()];
        return arrCheck.filter((item) => item < timeIn);
      };

      const onChangeNV = (value) => {
        setLsMemberSelected(value);
        form.setFieldsValue({ member: value });
        if (
          lsTeamSelected &&
          lsTeamSelected.length > 0 &&
          lsMember.length === 0
        ) {
          openNotificationWithIcon(
            "error",
            "Team đang chọn không có nhân viên chưa xếp lịch làm việc"
          );
        }
      };

      const check_req =
        (timeStartCa1 === null && timeEndCa1 !== null) ||
        (timeStartCa1 !== null && timeEndCa1 === null) ||
        (timeStart === null && timeEnd !== null) ||
        (timeStart !== null && timeEnd === null) ||
        (timeStartCa1 === null &&
          timeEndCa1 === null &&
          timeStart === null &&
          timeEnd === null);

      const handleClickDeleteEndCa1 = () => {
        if (timeEnd === null) {
          setTimeStartCa1(null);
          setTimeEndCa1(null);
        }
        form.setFieldsValue({ giovaoca1: timeStart });
        form.setFieldsValue({ gioraca1: timeEnd });

        setTimeStart(null);
        form.setFieldsValue({ giovao: null });

        setTimeEnd(null);
        form.setFieldsValue({ giora: null });
      };

      const handleClickDeleteEndCa2 = () => {
        setTimeStart(null);
        form.setFieldsValue({ giovao: null });

        setTimeEnd(null);
        form.setFieldsValue({ giora: null });
      };

      return (
        <Spin spinning={loading}>
          <div className={"row p-3 text-center"}>
            <Row>
              <Col span={11}>
                <Form.Item
                  name="team"
                  label="Team"
                  rules={[{ required: true, message: "Vui lòng chọn team" }]}
                >
                  <TreeSelect
                    className="styleSelect"
                    style={{ width: "100%" }}
                    value={lsTeamSelected}
                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    treeData={[
                      {
                        title:
                          lsTeamSelected && lsTeamSelected.length > 0 ? (
                            <span
                              onClick={() => {
                                setLsTeamSelected([]);
                                form.setFieldsValue({ team: [] });
                                onChangeTeam([]);
                              }}
                              style={{
                                display: "inline-block",
                                color: "#286FBE",
                                cursor: "pointer",
                              }}
                            >
                              Bỏ chọn tất cả
                            </span>
                          ) : (
                            <span
                              onClick={() => {
                                setLsTeamSelected(
                                  lsTeamRoleCreateOT.map((item) => item.idTeam)
                                );
                                form.setFieldsValue({
                                  team: lsTeamRoleCreateOT.map(
                                    (item) => item.idTeam
                                  ),
                                });
                                onChangeTeam(
                                  lsTeamRoleCreateOT.map((item) => item.idTeam)
                                );
                              }}
                              style={{
                                display: "inline-block",
                                color: "#286FBE",
                                cursor: "pointer",
                              }}
                            >
                              Chọn tất cả
                            </span>
                          ),
                        value: "xxx",
                        disableCheckbox: true,
                        disabled: true,
                      },
                      ...lsTeamRoleCreateOT.map((item) => {
                        return { title: item.team, value: item.idTeam };
                      }),
                    ]}
                    treeDefaultExpandAll
                    treeCheckable={true}
                    maxTagCount={5}
                    allowClear={false}
                    placeholder={"Chọn team"}
                    onChange={onChangeTeam}
                  />
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                {/* {lsTeamSelected.length > 0 && lsMember.length > 0 && */}
                <Form.Item
                  name="member"
                  label="Nhân viên"
                  rules={[
                    {
                      required: true,
                      type: "array",
                      message: "Vui lòng chọn nhân viên",
                    },
                  ]}
                >
                  <TreeSelect
                    className="styleSelect"
                    style={{ width: "100%" }}
                    value={lsMemberSelected}
                    dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                    treeData={[
                      {
                        title:
                          lsMemberSelected && lsMemberSelected.length > 0 ? (
                            <span
                              onClick={() => {
                                setLsMemberSelected([]);
                                form.setFieldsValue({ member: [] });
                              }}
                              style={{
                                display: "inline-block",
                                color: "#286FBE",
                                cursor: "pointer",
                              }}
                            >
                              Bỏ chọn tất cả
                            </span>
                          ) : (
                            <span
                              onClick={() => {
                                setLsMemberSelected(
                                  lsMember.map((item) => item.id)
                                );
                                form.setFieldsValue({
                                  member: lsMember.map((item) => item.id),
                                });
                              }}
                              style={{
                                display: "inline-block",
                                color: "#286FBE",
                                cursor: "pointer",
                              }}
                            >
                              Chọn tất cả
                            </span>
                          ),
                        value: "xxx",
                        disableCheckbox: true,
                        disabled: true,
                      },
                      ...lsMember.map((item) => {
                        return { title: item.username, value: item.id };
                      }),
                    ]}
                    treeDefaultExpandAll
                    treeCheckable={true}
                    maxTagCount={5}
                    allowClear={false}
                    placeholder={"Chọn member"}
                    onChange={(value) => onChangeNV(value)}
                    disabled={
                      !(lsTeamSelected.length > 0 && lsMember.length > 0)
                    }
                  />
                </Form.Item>
                {/* } */}
              </Col>
            </Row>
            <Row>
              <Col span={11}>
                <Form.Item
                  name="duan"
                  label="Chọn dự án"
                  rules={[
                    { required: true, message: "Vui lòng chọn 1 dự án." },
                  ]}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    className="styleSelect"
                    style={{ width: "100%" }}
                    placeholder="Chọn dự án"
                    maxTagCount={2}
                    filterOption={
                      (input, option) =>
                        option.props.children.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0 ||
                        option.props.key
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      // option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      // {console.log(option.props), false}
                    }
                    dropdownRender={(menu) => (
                      <>
                        <Col span={24} style={{ padding: "0 8px 4px" }}>
                          <Input
                            placeholder="Thêm dự án mới"
                            value={nameDuAn}
                            onChange={onNameChange}
                            onKeyPress={onKeyPress}
                            style={{ width: "100%" }}
                            addonAfter={
                              <Button
                                type="success"
                                shape="circle"
                                icon={<PlusOutlined />}
                                // style={{borderRadius: "50%!important", whiteSpace: 'nowrap'}}
                                title={"Thêm dự án mới"}
                                onClick={addItem}
                              />
                            }
                          />
                        </Col>
                        {menu}
                      </>
                    )}
                  >
                    {lsDuAnNew.map((item, index) => (
                      <Select.Option key={index + item.ten} value={item.id}>
                        <span>{item.ten}</span>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={11} offset={2}>
                <Form.Item
                  label="Ngày đăng ký"
                  name="ngaydangky"
                  rules={[
                    { required: true, message: "Vui lòng chọn ngày đăng ký" },
                  ]}
                >
                  <RangePicker
                    format={"DD/MM/YYYY"}
                    allowClear={false}
                    style={{ borderRadius: 10, width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="lich_dang_ky_ca">
              <Col span={24} style={{ paddingTop: 10 }}>
                <h4 style={{ fontWeight: 700 }}>Ca 1</h4>
              </Col>
              <Col span={4} style={{ display: "flex" }}>
                <Form.Item label="Giờ vào" name="giovaoca1">
                  <TimePicker
                    status={timeStartCa1 === null ? "error" : ""}
                    format="HH:mm"
                    placeholder={"Giờ vào"}
                    onSelect={(value) => {
                      onSelectTimeStartCa1(value);
                      form.setFieldsValue({ giovaoca1: value });
                    }}
                    style={{ borderRadius: 10, width: "100%" }}
                    value={timeStartCa1}
                    // inputReadOnly={true}
                    allowClear={false}
                    disabledHours={getDisableHourInCa1}
                    showNow={false}
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "auto" }}>
                {/* {timeStartCa1 !== null && (
                  <Button
                    className="button-delete-ot"
                    onClick={handleClickDeleteStartCa1}
                  >
                    <DeleteOutlined className="icon-delete-ot" />
                  </Button>
                )} */}
              </Col>
              <Col span={4} offset={1}>
                <Form.Item label="Giờ ra" name="gioraca1">
                  <TimePicker
                    status={
                      timeStartCa1 !== null && timeEndCa1 === null
                        ? "error"
                        : ""
                    }
                    format="HH:mm"
                    placeholder={"Giờ ra"}
                    onSelect={(value) => {
                      onSelectTimeEndCa1(value);
                      form.setFieldsValue({ gioraca1: value });
                    }}
                    style={{ borderRadius: 10, width: "100%" }}
                    value={timeEndCa1}
                    // inputReadOnly={true}
                    allowClear={false}
                    disabledHours={getDisableHourOutCa1}
                    showNow={false}
                    disabled={timeStartCa1 === null && true}
                  />
                </Form.Item>
              </Col>
              <Col span={1} style={{ margin: "auto" }}>
                {timeEndCa1 !== null && (
                  <Button
                    className="button-delete-ot"
                    onClick={handleClickDeleteEndCa1}
                  >
                    <DeleteOutlined className="icon-delete-ot" />
                  </Button>
                )}
              </Col>
              <Col span={11} offset={2}>
                <Form.Item label="Giải lao" name="giogiailaoca1">
                  <InputNumber
                    min={0}
                    placeholder="0 Phút"
                    style={{ borderRadius: 10, width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            {timeStartCa1 !== null && timeEndCa1 !== null && (
              <Row className="lich_dang_ky_ca">
                <Col span={24} style={{ paddingTop: 10 }}>
                  <h4 style={{ fontWeight: 700 }}>Ca 2</h4>
                </Col>
                <Col span={4}>
                  <Form.Item label="Giờ vào" name="giovao">
                    {/* <TimePicker.RangePicker placeholder={["Giờ vào", "Giờ ra"]} style={{borderRadius:10, width: '100%'}}/> */}
                    <TimePicker
                      status={
                        timeStart === null && timeEnd !== null ? "error" : ""
                      }
                      format="HH:mm"
                      placeholder={"Giờ vào"}
                      onSelect={(value) => {
                        onSelectTimeStart(value);
                        form.setFieldsValue({ giovao: value });
                      }}
                      style={{ borderRadius: 10, width: "100%" }}
                      value={timeStart}
                      // inputReadOnly={true}
                      allowClear={false}
                      disabledHours={getDisableHourIn}
                      showNow={false}
                    />
                  </Form.Item>
                </Col>
                <Col span={1} style={{ margin: "auto" }}>
                  {/* {timeStart !== null && (
                    <Button
                      className="button-delete-ot"
                      onClick={handleClickDeleteStartCa2}
                    >
                      <DeleteOutlined className="icon-delete-ot" />
                    </Button>
                  )} */}
                </Col>
                <Col span={4} offset={1}>
                  <Form.Item label="Giờ ra" name="giora">
                    <TimePicker
                      status={
                        timeStart !== null && timeEnd === null ? "error" : ""
                      }
                      format="HH:mm"
                      placeholder={"Giờ ra"}
                      onSelect={(value) => {
                        onSelectTimeEnd(value);
                        form.setFieldsValue({ giora: value });
                      }}
                      style={{ borderRadius: 10, width: "100%" }}
                      value={timeEnd}
                      // inputReadOnly={true}
                      allowClear={false}
                      disabledHours={getDisableHourOut}
                      showNow={false}
                      disabled={timeStart === null && true}
                    />
                  </Form.Item>
                </Col>
                <Col span={1} style={{ margin: "auto" }}>
                  {timeEnd !== null && (
                    <Button
                      className="button-delete-ot"
                      onClick={handleClickDeleteEndCa2}
                    >
                      <DeleteOutlined className="icon-delete-ot" />
                    </Button>
                  )}
                </Col>
                <Col span={11} offset={2}>
                  <Form.Item label="Giải lao" name="giogiailao">
                    <InputNumber
                      min={0}
                      placeholder="0 Phút"
                      style={{ borderRadius: 10, width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              <Col span={12} offset={6}>
                <Form.Item>
                  <Button
                    style={{ marginRight: 10 }}
                    type="primary"
                    loading={formLoading}
                    onClick={() => {
                      // @ts-ignore
                      form
                        .validateFields()
                        .then((r) => {
                          submit().then((result) => {
                            if (result === "ok") {
                              openNotificationWithIcon(
                                "success",
                                "Đăng ký thành công"
                              );
                            }
                            return false;
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }}
                    disabled={check_req}
                  >
                    Đăng ký
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Spin>
      );
    };

    return (
      <div>
        <div>
          <Form {...formProps} layout={"vertical"}>
            <FirstStep />
          </Form>
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={"Đăng ký lịch tăng ca"}
      width={800}
      visible={visible}
      onCancel={onCancel}
      footer={false}
    >
      <div className="row">
        <BoxNewSchedule_pro />
      </div>
    </Modal>
  );
};

export default ModalAddOvertime;
